import { useQuery } from '@tanstack/react-query';
import api from '../../services/api';
import { OBRAS_DEFAULT, TENSOES_DEFAULT } from './estoque.utils';

export function useObras() {
  const { data } = useQuery({
    queryKey: ['estoque-lista', 'obra'],
    queryFn: () => api.get('/estoque/config/listas?tipo=obra').then(r => r.data.data),
    staleTime: 60000,
  });
  return data?.filter(d => d.ativo).map(d => d.valor) || OBRAS_DEFAULT;
}

export function useTensoes() {
  const { data } = useQuery({
    queryKey: ['estoque-lista', 'tensao'],
    queryFn: () => api.get('/estoque/config/listas?tipo=tensao').then(r => r.data.data),
    staleTime: 60000,
  });
  return data?.filter(d => d.ativo).map(d => d.valor) || TENSOES_DEFAULT;
}

function getUser() {
  try { return JSON.parse(localStorage.getItem('user') || 'null'); } catch { return null; }
}

// Retorna objeto com permissões granulares do módulo Estoque para o usuário logado.
// { completo, any, dashboard, itens, novo, alertas, gerador_qr, scanner, configuracoes }
export function useEstoquePermissions() {
  const user = getUser();
  const tudo = { completo: true, any: true, dashboard: true, itens: true, novo: true, alertas: true, gerador_qr: true, scanner: true, configuracoes: true, trocar_qr: true };
  if (!user) return tudo;
  if (user.perfil === 'admin') return tudo;
  const mods = user.modulos_permitidos;
  if (!mods) return tudo;
  const completo = mods.includes('estoque');
  const has = (sub) => completo || mods.includes(`estoque.${sub}`);
  const any = completo || mods.some(m => m.startsWith('estoque.'));
  return { completo, any, dashboard: has('dashboard'), itens: has('itens'), novo: has('novo'), alertas: has('alertas'), gerador_qr: has('gerador_qr'), scanner: true, configuracoes: has('configuracoes'), trocar_qr: has('trocar_qr') };
}
